import { disallow } from 'feathers-hooks-common';
import { withSearch } from 'src/feathers/hooks';

const withSearches = withSearch(
  {
    email: withSearch.email,
    phone: withSearch.phone
  },
  (value, $or) => {
    if (value.endsWith(' ')) {
      value = value.trim();
      $or.push({ first_name: { $iLike: value } });
      return;
    }

    if (!value.includes(' ')) {
      value = value.trim();
      $or.push({ first_name: { $iLike: `${value}%` } });
      $or.push({ last_name: { $iLike: `${value}%` } });
      return;
    }

    const names = value.trim().split(' ');
    const first_name = names.slice(0, -1).join(' ').trim();
    const last_name = names[names.length - 1].trim();

    $or.push({
      $and: [
        { first_name: { $iLike: `${first_name}` } },
        { last_name: { $iLike: `${last_name}%` } }
      ]
    });
  }
);

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
